import auditTrailMutations from "./mutations.js";
import auditTrailActions from "./actions.js";
import auditTrailGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: auditTrailMutations,
  actions: auditTrailActions,
  getters: auditTrailGetters,
};
